import { UserDeck } from '@/types/deck';

interface DeckStatsProps {
  readonly filteredDecks: readonly UserDeck[];
  readonly selectedType: string;
  readonly searchQuery: string;
  readonly userDecks: readonly UserDeck[];
}

export function DeckStats({
  filteredDecks,
  selectedType,
  searchQuery,
  userDecks,
}: Readonly<DeckStatsProps>) {
  if (!filteredDecks || filteredDecks.length === 0) return null;

  return (
    <div className="w-full mb-4 text-sm text-muted-foreground flex items-center justify-between">
      <div>
        Showing {filteredDecks.length} {filteredDecks.length === 1 ? "deck" : "decks"}
        {selectedType !== "all" && (
          <span> in <span className="font-medium text-white capitalize">{selectedType}</span> category</span>
        )}
        {searchQuery && (
          <span> matching "<span className="font-medium text-white">{searchQuery}</span>"</span>
        )}
      </div>
      <div className="flex items-center gap-2">
        {userDecks && (
          <div className="flex items-center gap-2">
            <div className="w-3 h-3 rounded-full bg-green-500"></div>
            <span>{userDecks.filter(d => d.deck.membership === "free").length} Free</span>
          </div>
        )}
      </div>
    </div>
  );
}